// extracted by mini-css-extract-plugin
export default {"triangle":"CardFlipper_triangle__1OMdW","anim":"CardFlipper_anim__3g+fI","triangleAnimate":"CardFlipper_triangleAnimate__iblj4"};